import * as UI from "@iyk/ui"
import { Sheet } from "./sheet.tsx"

export const AlertCard = (props: AlertCard.Props) => {
  return (
    <Sheet.Root>
      <div className="flex flex-col p-3 gap-1.5 rounded bg-gray-12 [&>:first-child]:w-max">
        <UI.Badge kind={props.kind}>{props.eyebrow}</UI.Badge>
        <div className="flex items-start justify-between">
          <div className="flex flex-col gap-0.5">
            <span className="text-sm text-gray-1">{props.title}</span>
            <span className="text-xs text-gray-6">{props.subtitle}</span>
          </div>
          <Sheet.Trigger>
            <UI.Icon.Question className="text-gray-1" />
          </Sheet.Trigger>
          <Sheet.Content title={props.title} description={props.description}>
            <div className="mx-4 mt-10 mb-8">
              <UI.Badge kind={props.kind}>{props.eyebrow}</UI.Badge>
              <p className="text-xl mt-2">{props.title}</p>
              <span className="text-xs text-gray-11">{props.announcementDate}</span>
              <p className="text-sm text-gray-12 mt-6">{props.description}</p>
            </div>
          </Sheet.Content>
        </div>
      </div>
    </Sheet.Root>
  )
}

export namespace AlertCard {
  export type Props = {
    kind: "positive" | "caution"
    eyebrow: string
    title: string
    subtitle: string
    description: string
    announcementTitle: string
    announcementDate: string
  }
}
